import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IUserStore } from '../../../../__legacy__/modules/user/user.store';
import { ICursorControlBl } from '../CursorControl.bl';
import { CursorVisibilityCheckbox } from './CursorVisibilityCheckbox';

interface IProps {
  disabled: boolean;
}

export const CursorVisibilityCheckboxContainer = observer((props: IProps): ReactElement => {
  const bl = useInjection(ICursorControlBl.$);
  const userStore = useInjection(IUserStore.$);

  const handleChange = (): void => {
    bl.toggleImprovedVisibilityCursor();
  };

  return (
    <CursorVisibilityCheckbox
      disabled={props.disabled}
      checked={userStore.isImprovedVisibilityCursorEnabled}
      onChange={handleChange}
    />
  );
});
